namespace Matrix.Data {
    export interface CountryRow {
        CountryCode?: string;
        Name?: string;
        PrimaryCurrencyCode?: string;
        Isocode3?: string;
        DefaultSortOrder?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        RowId?: number;
        Version?: number;
    }

    export namespace CountryRow {
        export const idProperty = 'CountryCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.Country';
        export const lookupKey = 'Data.Country';

        export function getLookup(): Q.Lookup<CountryRow> {
            return Q.getLookup<CountryRow>('Data.Country');
        }
        export const deletePermission = 'DataAdmin:Country';
        export const insertPermission = 'DataAdmin:Country';
        export const readPermission = 'Read:Country';
        export const updatePermission = 'DataAdmin:Country';

        export declare const enum Fields {
            CountryCode = "CountryCode",
            Name = "Name",
            PrimaryCurrencyCode = "PrimaryCurrencyCode",
            Isocode3 = "Isocode3",
            DefaultSortOrder = "DefaultSortOrder",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            RowId = "RowId",
            Version = "Version"
        }
    }
}
